import { render, staticRenderFns } from "./cookie_policy.vue?vue&type=template&id=5b656534&scoped=true"
import script from "./cookie_policy.vue?vue&type=script&lang=js"
export * from "./cookie_policy.vue?vue&type=script&lang=js"
import style0 from "./cookie_policy.vue?vue&type=style&index=0&id=5b656534&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b656534",
  null
  
)

export default component.exports